export default __webpack_public_path__ + "static/media/Awards_IMG-Winner-01.3aa1eb7d.png";